let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fFQu3")).then(() => parcelRequire('4OF5s'));